import { useEffect, useState } from 'react'
import { WifiOff } from 'lucide-react'

export function PosOfflineBanner() {
  const [offline, setOffline] = useState(
    typeof navigator !== 'undefined' ? !navigator.onLine : false,
  )

  useEffect(() => {
    const goOffline = () => setOffline(true)
    const goOnline = () => setOffline(false)
    window.addEventListener('offline', goOffline)
    window.addEventListener('online', goOnline)
    return () => {
      window.removeEventListener('offline', goOffline)
      window.removeEventListener('online', goOnline)
    }
  }, [])

  if (!offline) return null

  return (
    <div className="flex items-center gap-2 border-b border-amber-300/60 bg-amber-50 px-4 py-2 text-sm text-amber-950">
      <WifiOff className="h-4 w-4 shrink-0" aria-hidden />
      <span>
        You are offline. Cached service catalog is available; new sales and payments need a connection.
      </span>
    </div>
  )
}
